/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "नमस्ते!",
  title1: 'BONJOUR!',
  title2: "Hello!",
  title3: "કેમ છો!",
  title4: "राधे राधे!",
  logo_name: "vibenr",
  nickname: "vib",
  full_name: "Vaibhav Chauhan",
  subTitle:
    "Full Stack Developer, Machine Learning Enthusiast. Always working on real-life problems.",
  resumeLink:
    "https://drive.google.com/file/d/1kcvW8P65jWZFeKR6Jopf3nrQLA1qJCwn/view?usp=sharing",
  mail: "mailto:sendonvaibhav.chauhan@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/vibenr",
  linkedin: "https://www.linkedin.com/in/vaibhav-chauhan-9a70871b9/",
  gmail: "sendonvaibhav.chauhan@gmail.com",
  gitlab: " ",
  facebook: " ",
  twitter: "https://twitter.com/vib_78",
  hashnode: "https://vibenr.hashnode.dev"
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using ReactJS and NextJS",
        "⚡ Backend development using NodeJS, ExpressJS and Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },

        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFFFFF",
            backgroundColor: "#1D1D1D",
            borderRadius: "50%",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },


        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },

        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },

        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },

    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience with firebase, managing Oauth",
        "⚡ Certified ML Developer on GCP",
        "⚡ Experience hosting and managing web apps on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
    {
      title: "Data Analytics & ML",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Experience of working with Data analytics and machine learning projects",
        "⚡ Certifications by Coursera",
        "⚡ Experience of working on National level hackathon's project: Advanced fake news detection system ",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
            color: "#6E6E6E",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "L.D. College of Engineering",
      subtitle: "B.E. in Information & Technology",
      logo_path: "ldce.png",
      alt_name: "LDCE",
      duration: "2020 - 2024",
      descriptions: [
        "⚡ A place that provided me enough amount of opportunities to fail and learn.",
        "⚡ An only finest engineering college of Gujarat where you get enough amount of freedom to explore.",
        "⚡ A place that transformed me from an introvert little boy to self-made man.",
      ],
      website_link: "https://www.ldce.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "How Google does Machine Learning",
      subtitle: "Google Cloud Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://coursera.org/verify/FSPWRXF6TZ9V",
      alt_name: "Google Cloud",
      color_code: "#ffc475",
    },
    {
      title: "Open Source Software Development Methods",
      subtitle: "The Linux Foundation",
      logo_path: "tlf.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/JD5ZGDJK4CUM",
      alt_name: "AMCAT",
      color_code: "#ffffff",
    },
    {
      title: "Employability Test",
      subtitle: "AMCAT Official",
      logo_path: "amcat_logo.png",
      certificate_link:
        "credential id: 360007208345865, verify at amcat.com/talentsearch",
      alt_name: "AMCAT",
      color_code: "#1e70c1",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've completed two internships. I've mostly done projects on my own and I am actively looking for internships. I love organizing various level of events and participate in hackathons.",
  header_image_path: "experience.svg",
  sections: [
    // {
    //   title: "Work",
    //   experiences: [
    //     {
    //       title: "IT Developer",
    //       company: "Canada Revenue Agency",
    //       company_url: "https://www.canada.ca/en/revenue-agency.html",
    //       logo_path: "cra.png",
    //       duration: "May 2023 - Ongoing",
    //       location: "Halifax, Nova Scotia",
    //       description:
    //         "Canada Revenue Agency (CRA) administers tax laws for the Government of Canada and for most provinces and territories, and administers various social and economic benefit and incentive programs delivered through the tax system.",
    //       color: "#f10000",
    //     },
    //     {
    //       title: "Full Stack Developer",
    //       company: "Quicko",
    //       company_url: "https://quicko.com/",
    //       logo_path: "quicko.jpg",
    //       duration: "June 2021 - October 2021",
    //       location: "Ahmedabad",
    //       description:
    //         "Quicko is an online tax planning, preparation & filing platform for individuals & businesses.",
    //       color: "#2962FF",
    //     },
    //   ],
    // },
    {
      title: "Internships",
      experiences: [
        {
          title: "Full Stack Developer Intern ",
          company: "WeHear – Hearing Solutions ",
          company_url: "https://wehear.in/",
          logo_path: "wehear.jpg",
          duration: "Nov 2022 - April 2023",
          location: "Remote",
          description:
            "Collaborated with cross-functional teams, and developed a full-stack HRMS system. | Engineered robust and scalable back-end systems, including high-performance APIs and database structures to deliver a flawless and immersive chat experience ",
          color: "#ffffff",
        },
        {
          title: "NODEJS Developer Intern",
          company: "Chipbucket Solutions Private Limited",
          company_url: "",
          logo_path: "chipbucket.png",
          duration: "August 2022 - September 2022",
          location: "Onsite | Ahmedabad, India",
          description:
            "Developed a REST API to manage all home devices using web app.",
          color: "#ffffff",
        },
      ],
    },
    {
      title: "Volunteering",
      experiences: [
        {
          title: "President",
          company: "Innovator Club, LDCE",
          company_url: "https://innovatorclubldce.org",
          logo_path: "innovator_club.png",
          duration: "June 2022 - Aug 2023",
          location: "L.D. College of Engineering, Ahmedabad",
          description:
            "As the President of the Innovator Club at LDCE, I bring a diverse set of skills in event management, leadership, communication, and collaboration to the table. My experience in organizing national and state-level events has equipped me with the expertise needed to deliver successful events that cater to the needs of our members and guests.",
          color: "#4285F4",
        },
        {
          title: "Content Writer",
          company: "Innovator Club, LDCE",
          company_url: "https://innovatorclubldce.org",
          logo_path: "innovator_club.png",
          duration: "Nov 2021 - June 2022",
          location: "L.D. College of Engineering, Ahmedabad",
          description:
            "I developed my documentation skills while working as a content writer. I learned how to manage some real-life documentation work.",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. I mainly work with web technology and machine learning. Note that not all of the mentioned projects are on public mode yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "vaibhav_pic.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "Visit my blogpost, I frequently write about various tools, ideas, technologies and development strategies.",
    link: "https://vibenr.hashnode.dev",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      name: "Bhoomi - Future of secure property transfers",
      url: "https://bhoomi.site",
      description: "A revolutionary project on the problem statement given by revenue department of India.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Solidity",
          iconifyClass: "devicon-solidity",
        },
        {
          name: "Material-UI",
          iconifyClass: "devicon-materialui",
        },
      ],
    },
    {
      name: "The Chanakya",
      url: "https://vibenr.hashnode.dev/the-chanakya-an-intelligent-fake-news-detector",
      description:
        "A solid proof of concept on advanced fake news detection system.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Pandas",
          iconifyClass: "logos-pandas",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
    },
    {
      name: "WEHEAR - HRMS",
      url: "#",
      description:
        "A user friendly and intuitive interface for thr HR Management System. [Internship Project]",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "ExpressJS",
          iconifyClass: "logos-express",
        },
      ],
    },
    {
      name: "IRADA 2022",
      url: "https://iradafest.vercel.app",
      description: "Developed a cutting-edge website to manage 25,000+ registration for national level fest from all over India.",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Django",
          iconifyClass: "logos-django",
        },
        {
          name: "MYSQL",
          iconifyClass: "logos-mysql",
        },
      ],
    },
    {
      name: "LDCE Student Portal",
      url: "#",
      description: "Digitalizing student portal activities, worked as a backend developer.",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Django",
          iconifyClass: "logos-django",
        },
        {
          name: "MYSQL",
          iconifyClass: "logos-mysql",
        },
      ],
    },
    {
      name: "Sorting Visualizer",
      url: "https://sorting-visualizer-woad.vercel.app/",
      description:
        "An interface to visualize sorting.",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      name: "Path Finding Visualizer",
      url: "https://pfvisualizer.vercel.app/",
      description:
        "An interface to visualiz path finding using graph traversal.",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      name: "Sentiment Analysis",
      url: "https://github.com/vibenr/sentiment_analysis",
      description:
        "Detailed sentiment analysis of amazon reviews.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Jupyter",
          iconifyClass: "logos-jupyter",
        },
        {
          name: "numpy",
          iconifyClass: "logos-numpy",
        },
        {
          name: "Matplotlitb",
          iconifyClass: "logos-matplotlib",
        },
      ],
    },
  ],
};

export
{
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
